import PropTypes from 'prop-types';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

import * as ST from './styled';

const CustomScrollbar = ({ customStyles = {}, hideTracksWhenNotNeeded = true, ...props }) => {
    const RenderView = ({ style, ...props }) => {
        return <ST.View
            extStyle={style}
            customStyles={customStyles}
            {...props}
        />;
    };

    const RenderTrackHorizontal = ({ style, ...props }) => {
        return <ST.TrackHorizontal
            extStyle={style}
            customStyles={customStyles}
            {...props}
        />;
    };

    const RenderTrackVertical = ({ style, ...props }) => {
        return <ST.TrackVertical
            extStyle={style}
            customStyles={customStyles}
            {...props}
        />;
    };

    const RenderThumbHorizontal = ({ style, ...props }) => {
        return (
            <ST.ThumbHorizontal
                extStyle={style}
                customStyles={customStyles}
                {...props}
            />
        );
    };

    const RenderThumbVertical = ({ style, ...props }) => {
        return (
            <ST.ThumbVertical
                extStyle={style}
                customStyles={customStyles}
                {...props}
            />
        );
    };

    return (
        <Scrollbars
            renderView={RenderView}
            renderTrackHorizontal={RenderTrackHorizontal}
            renderTrackVertical={RenderTrackVertical}
            renderThumbHorizontal={RenderThumbHorizontal}
            renderThumbVertical={RenderThumbVertical}
            hideTracksWhenNotNeeded={hideTracksWhenNotNeeded}
            {...props}
        />
    );
};

CustomScrollbar.propTypes = {
    customStyles: PropTypes.shape({
        view: PropTypes.object,
        trackVertical: PropTypes.object,
        thumbVertical: PropTypes.object,
        trackHorizontal: PropTypes.object,
        thumbHorizontal: PropTypes.object,
    }),
    hideTracksWhenNotNeeded: PropTypes.bool,
};

export default CustomScrollbar;
